import { Validator } from '@vista-digital/validator';
export const defaultSeatPickerAreaLabelsConfig = {
    margin: 10,
    show: false
};
export const seatPickerAreaLabelsConfigValidator = Validator.object({
    margin: Validator.number({ min: 0 }),
    show: Validator.boolean()
});
